import type { Course } from "../lib/types";

const c = "rgba(255,255,255,0.92)";

export function CourseArt({ kind }: { kind: Course["art"] }) {
  if (kind === "book")
    return (
      <svg width="84" height="64" viewBox="0 0 84 64" fill="none">
        <path
          d="M14 12h25a8 8 0 0 1 8 8v36a4 4 0 0 0-4-4H14z"
          stroke={c}
          strokeWidth="2"
        />
        <path
          d="M70 12H45a8 8 0 0 0-8 8v36a4 4 0 0 1 4-4h29z"
          stroke={c}
          strokeWidth="2"
        />
        <path
          d="M20 22h18M20 30h16M52 22h12M52 30h14"
          stroke={c}
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    );
  if (kind === "branch")
    return (
      <svg width="120" height="76" viewBox="0 0 120 76" fill="none">
        <line x1="14" y1="44" x2="106" y2="44" stroke={c} strokeWidth="2" />
        <path
          d="M50 44 Q60 24 78 24 L96 24"
          stroke={c}
          strokeWidth="2"
          fill="none"
        />
        <circle cx="22" cy="44" r="6" fill={c} />
        <circle cx="50" cy="44" r="6" fill={c} />
        <circle cx="78" cy="24" r="6" fill="#fff" stroke={c} strokeWidth="2" />
        <circle cx="96" cy="24" r="6" fill="#fff" stroke={c} strokeWidth="2" />
        <circle cx="98" cy="44" r="6" fill={c} />
      </svg>
    );
  if (kind === "cloud")
    return (
      <svg width="110" height="64" viewBox="0 0 110 64" fill="none">
        <path
          d="M30 22a16 16 0 0 1 32 2 12 12 0 1 1-2 24H32a14 14 0 0 1-2-26z"
          stroke={c}
          strokeWidth="2"
        />
        <path
          d="M48 30v18m0 0-6-6m6 6 6-6"
          stroke={c}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  if (kind === "pr")
    return (
      <svg width="110" height="74" viewBox="0 0 110 74" fill="none">
        <circle cx="28" cy="22" r="7" stroke={c} strokeWidth="2" />
        <circle cx="28" cy="58" r="7" stroke={c} strokeWidth="2" />
        <line x1="28" y1="29" x2="28" y2="51" stroke={c} strokeWidth="2" />
        <circle cx="82" cy="58" r="7" stroke={c} strokeWidth="2" />
        <path
          d="M82 51V32a8 8 0 0 0-8-8H40"
          stroke={c}
          strokeWidth="2"
          fill="none"
        />
        <path
          d="m44 28-6-4 6-4"
          stroke={c}
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  if (kind === "conflict")
    return (
      <svg width="116" height="68" viewBox="0 0 116 68" fill="none">
        <line x1="12" y1="34" x2="46" y2="34" stroke={c} strokeWidth="2" />
        <line x1="68" y1="34" x2="106" y2="34" stroke={c} strokeWidth="2" />
        <circle cx="20" cy="34" r="6" fill={c} />
        <circle cx="44" cy="34" r="6" fill={c} />
        <circle cx="72" cy="34" r="6" fill={c} />
        <circle cx="100" cy="34" r="6" fill={c} />
        <path
          d="M50 22l16 24M50 46l16-24"
          stroke="#FBA84A"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      </svg>
    );
  if (kind === "undo")
    return (
      <svg width="100" height="68" viewBox="0 0 100 68" fill="none">
        <path
          d="M22 34h44a14 14 0 0 1 14 14v0"
          stroke={c}
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="m32 22-10 12 10 12"
          stroke={c}
          strokeWidth="2"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  return null;
}
